import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd9adcbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "progress__main_container",
  class: "main_container"
}
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = { class: "header-left-title" }
const _hoisted_7 = { class: "header-right" }
const _hoisted_8 = {
  class: "ion-activatable ripple-parent",
  onclick: "location.href='/tabs/home'"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top_home",
  src: "/assets/icon/home.png",
  srcset: "/assets/icon/home@2x.png 2x,/assets/icon/home@3x.png 3x"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "top_container"
}
const _hoisted_12 = { class: "space-between" }
const _hoisted_13 = { class: "info_left" }
const _hoisted_14 = { class: "company_logo" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_17 = { class: "info_right" }
const _hoisted_18 = { class: "space-between" }
const _hoisted_19 = { class: "company_title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_b.png",
  srcset: "/assets/icon/btn_right_b@2x.png 2x,/assets/icon/btn_right_b@3x.png 3x"
}, null, -1))
const _hoisted_21 = { class: "company_info_right" }
const _hoisted_22 = {
  key: 0,
  class: "badge pink_badge"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge-txt white" }, " 조기모집완료 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge-bg red" }, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "pink_badge badge"
}
const _hoisted_27 = { class: "company_detail" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/leaf.png",
  class: "leaf"
}, null, -1))
const _hoisted_29 = { class: "green" }
const _hoisted_30 = { class: "deal_title" }
const _hoisted_31 = { class: "deal_content" }
const _hoisted_32 = { class: "space-between" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 클럽딜 규모 ", -1))
const _hoisted_34 = { class: "deal_right" }
const _hoisted_35 = { class: "bold" }
const _hoisted_36 = { class: "space-between" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 가격 ", -1))
const _hoisted_38 = { class: "deal_right" }
const _hoisted_39 = { class: "bold" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_42 = { class: "img_align help_circle" }
const _hoisted_43 = { class: "space-between" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deal_left" }, " 모집 기한 ", -1))
const _hoisted_45 = { class: "deal_right" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row deal_left" }, " 모집 현황 ", -1))
const _hoisted_47 = { class: "gauge_box" }
const _hoisted_48 = { class: "space-between" }
const _hoisted_49 = { class: "lead_info" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://pub.angelleague.io/images/company_logos/krafton.png",
  class: "c_logo"
}, null, -1))
const _hoisted_51 = { class: "deal_right" }
const _hoisted_52 = { class: "bold" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 원 참여 ")
const _hoisted_54 = { class: "white_container" }
const _hoisted_55 = { class: "notice_container" }
const _hoisted_56 = { class: "space-between" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "1인 참여 가능 범위", -1))
const _hoisted_58 = { class: "bold" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 원 ~ ")
const _hoisted_60 = { class: "bold" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_62 = { class: "space-between" }
const _hoisted_63 = { class: "help_circle" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" 서비스 이용료 ")
const _hoisted_65 = { class: "line_through" }
const _hoisted_66 = { class: "bold" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_68 = { class: "notice_box" }
const _hoisted_69 = { class: "white_container" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 함께 본 클럽딜 ", -1))
const _hoisted_71 = { class: "clubdeal-badge" }
const _hoisted_72 = { class: "logo" }
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "kakao_klip",
  src: "/assets/icon/kakao_klip.png"
}, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "regular" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "카카오톡"),
  /*#__PURE__*/_createTextVNode("에서 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "조합가입 증명카드"),
  /*#__PURE__*/_createTextVNode(" 확인하기 > ")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 기업 가치 "),
  /*#__PURE__*/_createElementVNode("div", { class: "value_image" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/assets/image/value_img.png" })
  ])
], -1))
const _hoisted_78 = { id: "info_box" }
const _hoisted_79 = { class: "info_container" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "info_container" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_84 = { class: "company_info" }
const _hoisted_85 = { class: "news_list" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_87 = { class: "news_list" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_89 = { class: "news_list" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_91 = { class: "news_list" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news_list" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수"),
  /*#__PURE__*/_createElementVNode("span", null, "30,049,313")
], -1))
const _hoisted_94 = { class: "info_container" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_96 = { class: "doc_left" }
const _hoisted_97 = { class: "item_left" }
const _hoisted_98 = { class: "series" }
const _hoisted_99 = { class: "info_date gray" }
const _hoisted_100 = { class: "doc_right" }
const _hoisted_101 = { class: "strong" }
const _hoisted_102 = { class: "info_container" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_104 = { class: "doc_left" }
const _hoisted_105 = { class: "info_date gray" }
const _hoisted_106 = ["onClick"]
const _hoisted_107 = { class: "doc_right" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "출자 위험 안내")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text" }, [
    /*#__PURE__*/_createTextVNode(" 본 위험고지서는 귀하가 (주)엔젤리그가 운영하는 서비스 위에서, 업무집행조합원과 함께 조합에 참여하여 조합을 공동경영하기 전에 출자의 위험을 사전에 충분히 인지할 수 있도록 (주)엔젤리그가 귀하에게 고지하는 내용입니다."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "1. 귀하의 출자대상은 조합의 지분으로서 투자대상회사의 주식 그 자체가 아닙니다. 설립되는 조합이 비상장주식을 매수하게 되며 귀하는 그 조합의 지분을 보유하게 됩니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "2. 조합의 업무집행조합원 및 다른 조합원은 귀하와 조합의 동업자로서, 조합 출자재산의 운영 및 배분은 조합원 전원의 합의로 이루어지고, 업무집행조합원은 조합의 출자재산을 운용하지 않습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "3. 조합의 매수대상인 투자대상회사의 증권은 원본손실의 위험성이 있으며, 출자한 자금의 원본을 회수할 없음에 따른 손실의 위험이 있음을 이해합니다. 또한 귀하가 예상하거나 기대하는 수익의 일부 또는 전부를 얻지 못할 수 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "4. 귀하는 (주)엔젤리그의 홈페이지에 게재된 매수대상회사에 대한 설명, 매수대상회사의 매수조건, 매수대상회사의 매수 시점 및 가격, 업무집행조합원의 성과보수, 업무집행조합원의 역할, 출자위험요소 등을 충분히 확인하였습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "5. 귀하는 (주)엔젤리그는 업무집행조합원이 안전하고 쉽게 조합을 만드는 것을 도와주는 역할만 수행하므로 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 조합의 업무집행조합원 역시 귀하와 같이 조합을 설립하고 운영하는 동업자로서 출자손실의 위험을 보전하는 당사자가 아님을 확인합니다. 즉, 출자에 대한 모든 위험은 본인에게 있음을 확인합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "6. 귀하는 조합을 통해 매수하는 매수대상회사의 비상장증권은 한국거래소의 상장을 목적으로 하는 것이 아니며, 따라서 증권의 환금성에 큰 제약이 있다는 점과 예상 회수금액에 대한 일부 혹은 전부를 회수할 수 없는 위험이 있음을 이해하며, 귀하가 이를 감당할 수 있음을 확인합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "7. 조합이 매수하게 되는 매수대상회사가 비상장 기업인 경우 성장초기단계에 있는 경우가 많기 때문에, 정기 배당을 실시하는 경우가 매우 드뭅니다. 따라서 배당수익을 기대하고 출자를 할 경우 기대한 만큼의 수익을 얻지 못할 수 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "8. 조합이 매수하게 되는 매수대상회사는 지속적으로 성장하기위하여 해당 기업의 정관에 근거하여 유상증자를 실시할 가능성이 높습니다. 유상증자로 인하여 조합이 보유한 지분율은 감소될 수 있습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "9. 귀하는 시장의 상황, 제도의 변경이 있을 수 있으며, 자본시장법 등 관련법규에 근거하여 출자의 한도에 제한이 있는 경우 이를 준수하여야 함을 이해합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "10. 귀하는 귀하가 보유한 조합의 지분에 대하여 원칙적으로 1년간 전매가 제한된다는 점을 이해합니다. 단, 조합이 보유한 매수대상회사의 주식은 아무런 제한 없이 매매가 가능합니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "위 사항들은 조합의 출자에 수반되는 위험과 관련하여 귀하가 알아야 할 사항을 간략하게 서술한 것으로 귀하의 위 거래와 관련하여 발생될 수 있는 모든 위험과 중요 사항을 전부 기술한 것은 아닙니다. 따라서 상세한 내용은 (주)엔젤리그 및 관계법규를 통하여 확인하여야 합니다.")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "medium" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "환불 정보")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "refund_list" }, [
      /*#__PURE__*/_createElementVNode("li", null, "단순 변심으로 인한 환불 : 환불 수수료 10만원"),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 발송 이후 : 환불 수수료 20만원 "),
      /*#__PURE__*/_createElementVNode("li", null, "조합규약 서명 이후 : 환불 불가")
    ]),
    /*#__PURE__*/_createTextVNode(" 비상장주식회사의 비통일주권의 거래를 위해,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 주식양수도계약, 명의개서*를 완료 해야 합니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 본 과정은 리드엔젤과 (주)엔젤리그가 안전하게 진행합니다. 단, 계약이 완료되지 못한 경우, 바로 공지드리며 영업일 기준 D+8내에 입력하신 환불계좌로 전액 환불됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 입금 선착순에 의한 환불인 경우 사용된 포인트는 3영업일 이내에 복원됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "blue sub_text" }, "*명의개서 : 회사에서 주주명부에 새로운 주주로 등재하는 것")
  ])
], -1))
const _hoisted_111 = { class: "white_container" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "related_title" }, " 함께 본 클럽딜 ", -1))
const _hoisted_113 = { class: "clubdeal-badge" }
const _hoisted_114 = { class: "logo" }
const _hoisted_115 = ["src"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_117 = { class: "white_container" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "엔젤리그 사용법")
], -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/image/img.png",
    alt: ""
  })
], -1))
const _hoisted_120 = {
  id: "info",
  class: "ion-activatable ripple-parent info_btn",
  style: {"background":"#222"}
}
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" 엔젤리그소개 ")
const _hoisted_122 = {
  id: "FAQ",
  class: "ion-activatable ripple-parent info_btn",
  style: {"background":"#4360EC"}
}
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" 자주묻는질문 ")
const _hoisted_124 = {
  id: "process",
  class: "ion-activatable ripple-parent info_btn",
  style: {"background":"#00B7B9"}
}
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" 조합생성과정 ")
const _hoisted_126 = {
  key: 0,
  class: "footer_container space-between"
}
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" 클럽딜 참여하려면 로그인 > ")
const _hoisted_128 = {
  src: "/assets/icon/btn_open.png",
  alt: "",
  class: "btn_open",
  srcset: "/assets/icon/btn_open@2x.png 2x,/assets/icon/btn_open@3x.png 3x"
}
const _hoisted_129 = {
  key: 2,
  class: "ion-activatable ripple-parent heart_btn"
}
const _hoisted_130 = ["src"]
const _hoisted_131 = {
  key: 1,
  class: "footer_container space-between"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray_btn footer_btn" }, " 준비 중인 클럽딜 ", -1))
const _hoisted_133 = {
  key: 0,
  src: "/assets/icon/heart_w.png",
  srcset: "/assets/icon/heart_w@2x.png 2x,/assets/icon/heart_w@3x.png 3x"
}
const _hoisted_134 = {
  key: 1,
  src: "/assets/icon/heart_n.png",
  srcset: "/assets/icon/heart_n@2x.png 2x,/assets/icon/heart_n@3x.png 3x"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slide_up",
  src: "/assets/icon/slide_up_gray.png",
  alt: ""
}, null, -1))
const _hoisted_136 = [
  _hoisted_135
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "ionContentClubDealProgress",
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, {
                "pulling-icon": _ctx.arrowDownOutline,
                "refreshing-spinner": "crescent"
              }, null, 8, ["pulling-icon"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.go(-1)))
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.partnershipInfo.partnershipName), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ])
            ]),
            _hoisted_10,
            (!_ctx.fromCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "img-responsive img-circle",
                          src: _ctx.partnershipInfo.companyLogo,
                          alt: "img-circle img-responsive"
                        }, null, 8, _hoisted_15),
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent company_info_left",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useCompanyModal(_ctx.partnershipInfo.stockItemId)))
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.partnershipInfo.stockItemName) + " ", 1),
                            _hoisted_20
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            (_ctx.partnershipInfo.partnershipStatus=='collected'&&_ctx.partnershipInfo.inPeriod=='in')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                              : _createCommentVNode("", true),
                            (_ctx.partnershipInfo.badgeTxt)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.partnershipInfo.badgeTxt), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", null, "추정 기업가치 " + _toDisplayString(_ctx.filter.numberToKorean(_ctx.partnershipInfo.currentValuation)) + "원", 1),
                          _hoisted_28,
                          _createElementVNode("span", _hoisted_29, _toDisplayString(Number(_ctx.boardSummary.avg_point).toFixed(1)), 1),
                          _createTextVNode(" · " + _toDisplayString(_ctx.boardSummary.count) + "명 ", 1)
                        ]),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "content_wrap",
              style: _normalizeStyle({'background' : `${_ctx.partnershipInfo.bgColor}`, 'color' : `${_ctx.partnershipInfo.fontColor}`})
            }, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.partnershipInfo.partnershipName) + " 정보 ", 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalStockAmount)), 1),
                    _createTextVNode(" 원 (" + _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.totalQty)) + "주) ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", null, [
                      (_ctx.hasSession())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.price)), 1),
                            _hoisted_40
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_41
                          ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", null, "기업가치 " + _toDisplayString(_ctx.filter.numberToKorean(_ctx.partnershipInfo.price*_ctx.partnershipInfo.totalStockAmount)) + "원 가격 ", 1),
                      _createElementVNode("img", {
                        src: "/assets/icon/help_circle.png",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPopover && _ctx.openPopover(...args)))
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.filter.getDate(_ctx.partnershipInfo.dueDateFrom)) + " ~ " + _toDisplayString(_ctx.filter.getDate(_ctx.partnershipInfo.dueDate)) + " (모집완료) ", 1)
                ]),
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_ion_progress_bar, {
                    value: `${_ctx.partnershipInfo.collectedRate}`
                  }, null, 8, ["value"]),
                  _createElementVNode("span", {
                    class: "gauge_text",
                    style: _normalizeStyle({'left' : `calc(${_ctx.partnershipInfo.collectedRate * 0.93}%)`, 'color' : `${_ctx.partnershipInfo.bgColor}`})
                  }, _toDisplayString(_ctx.partnershipInfo.collectedRate) + "% ", 5)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.nickname) + " 리드엔젤", 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.leadAsset)), 1),
                    _hoisted_53
                  ])
                ])
              ])
            ], 4),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.availableAssetFrom)), 1),
                    _hoisted_59,
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.availableAssetTo)), 1),
                    _hoisted_61
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("img", {
                      src: "/assets/icon/help_circle.png",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openPopoverFee && _ctx.openPopoverFee(...args)))
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.defaultFee)) + " 원", 1),
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipInfo.serviceFeeAmount)), 1),
                    _hoisted_67
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, " MY 포인트 = " + _toDisplayString(_ctx.$filters.currency(_ctx.userAvailablePoint)) + "p | 포인트 쓰면 이용료 무료! ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendPartnership, (v, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: (v, idx),
                  class: "badge-container"
                }, [
                  _createVNode(_component_router_link, {
                    to: {name:'ClubDealProgress', params: {clubdeal_id: v.partnershipId}},
                    push: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent deal-badge",
                        style: _normalizeStyle({'background' : `${_ctx.recommendPartnership[idx].bgColor}`})
                      }, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("img", {
                            src: _ctx.recommendPartnership[idx].companyLogo ? _ctx.recommendPartnership[idx].companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_73),
                          _hoisted_74
                        ]),
                        _createElementVNode("div", {
                          class: "collecting",
                          style: _normalizeStyle({'color' : `${_ctx.recommendPartnership[idx].fontColor}`})
                        }, _toDisplayString(_ctx.recommendPartnership[idx].partnershipName), 5),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 4)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent white_container",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.viewKakaoKlipModal && _ctx.viewKakaoKlipModal(...args)))
          }, [
            _hoisted_75,
            _hoisted_76,
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ]),
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.press, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "ion-activatable ripple-parent news_list",
                  onClick: ($event: any) => (_ctx.openLink(v.link))
                }, [
                  _createTextVNode(_toDisplayString(v.title) + " ", 1),
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ], 8, _hoisted_81))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_82, [
              _hoisted_83,
              _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.partnershipInfo.introduction), 1),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.stockItemName), 1)
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.ceo), 1)
              ]),
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("span", null, _toDisplayString(_ctx.partnershipInfo.bizno), 1)
              ]),
              _createElementVNode("div", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.transDate(_ctx.partnershipInfo.foundDate)), 1)
              ]),
              _hoisted_93
            ]),
            _createElementVNode("div", _hoisted_94, [
              _hoisted_95,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.investHistory, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, " Serires " + _toDisplayString(v.series), 1),
                      _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.$filters.transDate(v.date)), 1)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(v.investor), 1)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("span", _hoisted_101, _toDisplayString(v.value), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_102, [
              _hoisted_103,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipInfo.publicAnnouncement, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v,
                  class: "news_list space-between"
                }, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$filters.transDate(v.date)), 1),
                    _createElementVNode("span", {
                      class: "ion-activatable ripple-parent info_link",
                      onClick: ($event: any) => (_ctx.openLink(v.link))
                    }, [
                      _createTextVNode(_toDisplayString(v.title) + " ", 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_106)
                  ]),
                  _createElementVNode("div", _hoisted_107, _toDisplayString(v.sender), 1)
                ]))
              }), 128))
            ]),
            _hoisted_108,
            _hoisted_109,
            _hoisted_110,
            _createElementVNode("div", _hoisted_111, [
              _hoisted_112,
              _createElementVNode("div", _hoisted_113, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendPartnership, (v, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: (v, idx),
                    class: "badge-container"
                  }, [
                    _createVNode(_component_router_link, {
                      to: {name:'ClubDealProgress', params: {clubdeal_id: v.partnershipId}},
                      push: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "ion-activatable ripple-parent deal-badge",
                          style: _normalizeStyle({'background' : `${_ctx.recommendPartnership[idx].bgColor}`})
                        }, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("img", {
                              src: _ctx.recommendPartnership[idx].companyLogo ? _ctx.recommendPartnership[idx].companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-responsive img-circle"
                            }, null, 8, _hoisted_115),
                            _hoisted_116
                          ]),
                          _createElementVNode("div", {
                            class: "collecting",
                            style: _normalizeStyle({'color' : `${_ctx.recommendPartnership[idx].fontColor}`})
                          }, _toDisplayString(_ctx.recommendPartnership[idx].partnershipName), 5),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ], 4)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_117, [
              _hoisted_118,
              _hoisted_119,
              _createElementVNode("div", {
                class: "space-between",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFAQModal($event.target.id)))
              }, [
                _createElementVNode("div", _hoisted_120, [
                  _hoisted_121,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _hoisted_125,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, {
        class: "ion-no-border",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              (_ctx.showToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    (_ctx.user === null)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "ion-activatable ripple-parent footer_btn red_btn",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$global.openLoginModal(_ctx.refresh)))
                        }, [
                          _hoisted_127,
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([{'blue_btn' : _ctx.submitButtons[0].code=='join',
                     'red_btn' : _ctx.submitButtons[0].code=='anotherNotYet',
                     'gray_btn' : _ctx.submitButtons[0].code=='comingSoon' || _ctx.submitButtons[0].code=='paid' || _ctx.submitButtons[0].code=='cancel'|| _ctx.submitButtons[0].code=='complete'}, "ion-activatable ripple-parent footer_btn"]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.btnClick(`${_ctx.submitButtons[0].code}`)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.submitButtons[0].name) + " ", 1),
                          _withDirectives(_createElementVNode("img", _hoisted_128, null, 512), [
                            [_vShow, _ctx.submitButtons[0].code=='anotherNotYet']
                          ]),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ], 2)),
                    (_ctx.btnToggle && (_ctx.submitButtons[0].code === 'join' || _ctx.submitButtons[0].code === 'comingSoon'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                          _createElementVNode("img", {
                            src: _ctx.submitButtons[1].code === 'unlike' ? '/assets/icon/heart_w.png' : '/assets/icon/heart_g.png',
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.heartToggle(_ctx.partnershipInfo.partnershipStatus, _ctx.partnershipInfo.partnershipId)))
                          }, null, 8, _hoisted_130),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.submitButtons[1].code === 'unlike' ? {'color' : '#fff'} : { 'color' : '#8F929B'} )
                          }, _toDisplayString(_ctx.partnershipInfo.likeCount), 5),
                          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", {
                      class: "orange_btn footer_btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.router.push({ name: 'MyPage' })))
                    }, " 출자금 입금 확인중 ", 512), [
                      [_vShow, _ctx.submitButtons[0].code=='cancel']
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("div", {
                      class: "heart_btn",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.partnershipLike(_ctx.partnershipInfo.partnershipId)))
                    }, [
                      (_ctx.partnershipInfo.partnershipLikeId)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_133))
                        : (_openBlock(), _createElementBlock("img", _hoisted_134)),
                      _createElementVNode("div", {
                        class: _normalizeClass({gray:!_ctx.partnershipInfo.partnershipLikeId})
                      }, _toDisplayString(_ctx.partnershipInfo.likeCount), 3)
                    ])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: "progress__scroll_top_btn",
        class: "scrollTopBtn",
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
      }, _hoisted_136)
    ]),
    _: 1
  }))
}